import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SearchItem, SearchItemType } from '../../SearchItem';
import { ClearButton, Label, QueriesContainer, SearchSubHeader } from './RecentSearchBody.styles';
export function RecentSearchBody(_ref) {
  let {
    hits,
    onClearAll,
    autocomplete,
    onAppend: _onAppend
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchSubHeader, null, /*#__PURE__*/React.createElement(Label, null, "Recent searches"), /*#__PURE__*/React.createElement(ClearButton, {
    type: "button",
    role: "button",
    onClick: onClearAll,
    "aria-label": "Clear past searches"
  })), /*#__PURE__*/React.createElement(QueriesContainer, null, hits.map(collection => {
    const {
      source,
      items
    } = collection;
    return items.length > 0 && items.map(item => /*#__PURE__*/React.createElement(SearchItem, _extends({
      key: item.objectID,
      type: SearchItemType.RECENT,
      onAppend: () => _onAppend(item),
      item: item
    }, autocomplete.getItemProps({
      item,
      source
    }))));
  })));
}